import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { ErrorBoundary } from "@/components/error-boundary";
import { BugReportWidget } from "@/components/bug-report";
import { TkcOpsCenter } from "@/components/tkc-ops-center";

export const Route = createFileRoute("/ops")({
  head: () => ({
    meta: [
      { title: "TKC Ops Command Center — Need Navigator | AROS FLOW" },
      {
        name: "description",
        content:
          "Money-first triage, 30/30/40 lanes, Need Navigator, buy box verification and exit-stack ranking — routed straight into the AROS FLOW deal tools.",
      },
      { property: "og:title", content: "TKC Ops Command Center — AROS FLOW" },
      {
        property: "og:description",
        content:
          "Find the need, score the evidence, rank the money path, then run the numbers in the deal desk.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: OpsPage,
});

function OpsPage() {
  return (
    <AppShell>
      <ErrorBoundary label="TKC Ops Command Center">
        <TkcOpsCenter />
      </ErrorBoundary>
      <BugReportWidget />
    </AppShell>
  );
}
